import React from 'react';
import Navigation from './Navigation';
import Hero from './Hero';
import About from './About';
import ExperienceTimeline from './ExperienceTimeline';
import ProjectsSection from './ProjectsSection';
import ContactSection from './ContactSection';
import Skills from './Skills';

function Portfolio() {
    return (
        <div className="portfolio">
            <Navigation />
            <main>
                <Hero />
                <About />
                <Skills/>
                <ExperienceTimeline/>
                <ProjectsSection />
                <ContactSection />
            </main>
        </div>
    );
}

export default Portfolio;